import React from 'react';
import { t } from '../i18n';

export default function Hero({ lang }) {
  const c = t(lang);

  return (
    <section className="relative min-h-[100svh] flex items-end md:items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=2000&q=80"
          alt=""
          className="w-full h-full object-cover scale-105 animate-slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#062828]/96 via-[#0C3C3C]/88 to-[#0C3C3C]/55" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#062828] via-transparent to-[#0C3C3C]/40" />
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-16 md:py-32">
        <div className="max-w-2xl animate-fade-up">
          <p className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white leading-[1.05] mb-5">
            {c.hero.brand}
          </p>
          <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold text-teal-100/95 leading-snug mb-4 max-w-xl">
            {c.hero.headline}
          </h1>
          <p className="text-base sm:text-lg text-teal-50/75 leading-relaxed mb-8 max-w-lg">
            {c.hero.sub}
          </p>
          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
            <a
              href="/s"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-teal-300 hover:bg-white text-teal-950 font-bold text-base rounded-md transition-all duration-300 hover:-translate-y-0.5 animate-cta-pulse"
            >
              {c.hero.cta}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2.5}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>
            <p className="text-sm text-teal-100/60">{c.hero.note}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
